import styled from 'styled-components'
import WarningIcon from '@mui/icons-material/Warning'
import AlarmIcon from '@mui/icons-material/Alarm'
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined'
import { Card } from '../../components'
import { useNavigate } from 'react-router-dom'
import { useAdministrativeActionsModal } from '../../contexts/AdministrativeActionsModalContext'

const Container = styled.div`
  display: flex;
  gap: 24px;
  overflow-x: auto;
`

const icons = {
  colaborators: <WarningIcon />,
  'alarme-clock': <AlarmIcon />,
  pen: <CreateOutlinedIcon />,
}

const handleClick = ({
  action,
  link,
  setLink,
  openModal,
  setText,
  customMessage,
  navigate,
}) => {
  if (action === 'intervention-modal') {
    setLink(link)
    if (customMessage) setText(customMessage)
    openModal()
    return
  }
  navigate(link)
  return
}

const CardNotificationList = ({ cards }) => {
  const { openModal, setLink, setText } = useAdministrativeActionsModal()
  const navigate = useNavigate()
  return (
    <Container>
      {cards.map(({ text, image, link, action, customMessage }) => {
        return (
          <Card
            key={text}
            image={icons[image] || icons['default']}
            description={text}
            onClick={() =>
              handleClick({
                action,
                link,
                openModal,
                setLink,
                setText,
                customMessage,
                navigate,
              })
            }
          />
        )
      })}
    </Container>
  )
}

export default CardNotificationList
